export default function widthValidator(width: string | undefined) {
  if (width === '' || width === undefined) {
    return 'Ширина не может быть пустой';
  }
  if (isNaN(Number(width))) {
    return 'Не удалось преобразовать ширину в число';
  }
  if (+width <= 0) {
    return 'Ширина не может быть меньше или равна 0';
  }
  if (+width >= 10000) {
    return 'Ширина не может быть больше или равна 10000';
  }
  return undefined;
}
